import type { UserAccount } from "@/api/queries";

export function hasAdminRights(myAccount: UserAccount | undefined): boolean {
  return (myAccount?.permission ?? 999) < 3;
}

export function isSelfServiceCatalogue(catalogueCode: string): boolean {
  const selfServiceCatalogues = [
    "ECH0000000001C", // Test & Debug
    "SEN0000001063C", // Production
  ];
  return selfServiceCatalogues.includes(catalogueCode);
}

export function isTunecoreCatalogue(catalogueCode: string): boolean {
  const tunecoreCatalogues = [
    "TUN0000000001C",
  ];
  return tunecoreCatalogues.includes(catalogueCode);
}
